import * as types from "redux/actions/actionTypes";

const initialState = {
  list: [],
  clientData: {},
  clientUsers: [],
  clientUserRoles: {},
  selectedClientId: null,
  selectedClient: null,
};

export default function clientReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_CLIENTS: {
      const { data } = action.payload;
      return {
        ...state,
        clientData: {},
        clientUsers:[],
        clientUserRoles: {},
        list: data,
      };
    }

    case types.SET_SELECTED_CLIENT_ID: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case types.SET_SELECTED_CLIENT: {
      return {
        ...state,
        ...action.payload,
        selectedClientId: action.payload.selectedClient?.clientId ?? null,
      };
    }

    case types.GET_CLIENT: {
      const { data } = action.payload;

      return {
        ...state,
        clientData: data,
      };
    }

    case types.GET_CLIENTS_USERS: {
      const { data } = action.payload;

      return {
        ...state,
        clientUsers: data,
      };
    }

    case types.UPDATE_CLIENT: {
      const { data } = action.payload;

      return {
        ...state,
        selectedClient: data,
        clientData: data,
      };
    }

    case types.GET_CLIENTS_USER_ROLES: {
      const { data } = action.payload;

      return {
        ...state,
        clientUserRoles: {
          ...data,
          clientUserRoles: data.clientUserRoles.map((item, index) => ({
            ...item,
            id: index + 1,
          })),
        },
      };
    }

    default:
      return state;
  }
}
